import { useMemo } from 'react';

import { FeatureFlag, useFeatureFlags } from 'shared/domains/featureFlag';

interface AllowedPlatformFeatures {
  alertsAllowed: boolean;
  customColumnsAllowed: boolean;
  editAdminTeamsAllowed: boolean;
  policiesAllowed: boolean;
  readonlyUserEditDisabled: boolean;
  reportsAllowed: boolean;
  usageAllowed: boolean;
}

export const useAllowedPlatformFeatures = (): AllowedPlatformFeatures => {
  const { featureFlags } = useFeatureFlags();

  const policies = featureFlags[FeatureFlag.ALLOWED_TO_VIEW_POLICIES];
  const usage = featureFlags[FeatureFlag.USAGE_ACCESS];
  const reports = featureFlags[FeatureFlag.ALLOWED_TO_VIEW_REPORTS];
  const editAdminTeams = featureFlags[FeatureFlag.ALLOWED_TO_EDIT_ADMIN_TEAMS];
  const { enabled: customColumns } = featureFlags[FeatureFlag.ALLOWED_CUSTOM_COLUMNS];
  const alerts = featureFlags[FeatureFlag.ALERTS_ACCESS];
  const readonlyUserEditDisabled = featureFlags[FeatureFlag.READONLY_USER_EDIT_DISABLED];

  return useMemo(() => {
    return {
      alertsAllowed: String(alerts) === 'true',
      customColumnsAllowed: String(customColumns) === 'true',
      editAdminTeamsAllowed: String(editAdminTeams) === 'true',
      policiesAllowed: String(policies) === 'true',
      readonlyUserEditDisabled: String(readonlyUserEditDisabled) === 'true',
      reportsAllowed: String(reports) === 'true',
      usageAllowed: String(usage) === 'true',
    };
  }, [customColumns, reports, editAdminTeams, policies, usage, alerts, readonlyUserEditDisabled]);
};
